module.exports = __webpack_public_path__ + "img/226.90ac2b5a.jpg";